export const ciCustomColors = {
  blue: {
    10: "#F8FAFC",
    25: "#EAF1FA",
    50: "#E8EDF3",
    100: "#EAF1FA",
    300: "#B3DBF1",
    450: "#1976D214",
    500: "#237AC3",
    600: "#E8EDF366",
  },
  blueGrey: {
    900: "#263238",
  },
  red: {
    100: "#FEEBEE",
  },
  grey: {
    50: "#FAFAFA",
    300: "#E0E0E0",
  },
  green: {
    200: "#DBEFDC",
  },
  dark: {
    100: "#252525",
  },
  cyan: {
    900: "#006064",
  },
};
